/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/partialpaymentreport.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_PARTIAL_PAYMENT_USERS, GET_PRESENTATIONS } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment";
import { pretty } from "@vlinder-web/utils-react";

const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetPartialPaymentUsersMethods extends IPluginMethodMap {
  getPartialPaymentUsers(args: any): Promise<any>;
}

export class GetPartialPaymentUsersService implements IAgentPlugin {
  readonly methods: IGetPartialPaymentUsersMethods;

  constructor() {
    this.methods = {
      getPartialPaymentUsers: this.getPartialPaymentUsers.bind(this),
    };
  }

  async getPartialPaymentUsers(args?: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    console.log("args in Partial payment service====", pretty(args));
    let filer_apply = args?.criteria ? args?.criteria : {};
    let presentationOptions: any = [],
      defaultPresentation: any = "";
    console.log("filet apply====", filer_apply);

    filer_apply = this.convertCriteria(args?.criteria);
    let variables = {
      options: {
        limit: args?.size ?? 10,
        skip: args?.offset ?? 0,
        sort: {
          field: "createdAt",
          order: "desc",
        },
      },
      filter: {
        paymentStats: {
          eq: "Partial",
        },
        ...filer_apply,
      },
    };
    console.log("filter in Partial payment user", variables);
    const _filter = {
      // status: {
      //   eq: "active",
      // },
      // year: {
      //   eq: "2024",
      // },
    };
    try {
      if (client) {
        const presentation = await client.query({
          query: GET_PRESENTATIONS,
          variables: {
            filter: _filter,
            options: {
              limit: 10,
              skip: 0,
              sort: {
                field: "status",
                order: "asc",
              },
            },
          },
          fetchPolicy: "network-only",
        });
        if (
          presentation &&
          presentation?.data?.getPresentations?.content[0]?.id
        ) {
          defaultPresentation =
            presentation?.data?.getPresentations?.content[0]?.id;
          presentationOptions =
            presentation?.data?.getPresentations?.content?.map((_item: any) => {
              return { value: _item?.id, label: _item?.name };
            });
          variables.filter.presentation = {
            eq: args?.criteria?.presentation ?? defaultPresentation,
          };
        }
        const res = await client.query({
          query: GET_PARTIAL_PAYMENT_USERS,
          variables: variables,
          fetchPolicy: "network-only",
        });

        if (res?.data) {
          let _rowData = this.formatTable(
            res?.data?.getUserAdvancedSearch?.content
          );

          let _totalPages = res?.data?.getUserAdvancedSearch?.count
            ? Math.ceil(parseInt(res?.data?.getUserAdvancedSearch?.count) / 10)
            : 1;

          let _currentPage =
            res?.data?.getUserAdvancedSearch?.skip /
            res?.data?.getUserAdvancedSearch?.limit +
            1;
          console.log("_rowData==>", _rowData);
          return {
            ...config,
            ultUsers: _rowData,
            isEmpty: res?.data?.getUserAdvancedSearch?.content?.length <= 0,
            activePage: _currentPage,
            currentPage: _currentPage,
            pageSize: _rowData.length,
            totalCount: res?.data?.getUserAdvancedSearch?.count,
            totalPages: _totalPages,
            searchPresentationFilter: presentationOptions,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
  }

  private convertCriteria(criteria: any) {
    const result: any = {};
    for (const key in criteria) {
      if (key != "presentation") result[key] = { contains: criteria[key] };
    }
    return result;
  }

  private formatTable(users: any[]): any {
    let _rowData: any = [];
    let totalPaid = users.length > 0 ? 0 : "";
    users &&
      users.forEach((data?: any) => {
        _rowData.push({
          id: data?._id,
          name: data?.User?.fullName ?? "Null Null",
          email: data?.User?.email ?? "-",
          userId: data?.User?._id,
          Committee:
            data?.ReferalUsers.length > 0
              ? data?.ReferalUsers[0]?.fullName
              : "-",
          dateCreated: data?.createdAt
            ? moment(data?.createdAt).format("L")
            : "",
          costPaid: data?.PayOrders?.amountPaid
            ? data?.PayOrders?.amountPaid.toFixed(2)
            : 0,
          totalCost: data?.totalAmount ? data?.totalAmount.toFixed(2) : 0,
          TypeName: data?.CostumeType?.name ?? "-",
          SectionName: data?.Section?.name ?? "-",
        });
        // }
      });
    return _rowData;
  }
}
